"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var ConjugationTableWrapper = function ConjugationTableWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.loadConjugatedVerbStrings = function () {
        if (_this.wordId) {
          _stores.ConjugatedVerbStringStore.getIndex({
            ids: {
              wordId: _this.wordId
            }
          });
        }
      };
      _this.loadConjugatedVerbStrings();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "wordId",
      get: function get() {
        var _this$word;
        return (_this$word = this.word) === null || _this$word === void 0 ? void 0 : _this$word.id;
      }
    }, {
      key: "word",
      get: function get() {
        return (0, _utils.isPresent)(_state.DeckUI.deck.words) ? _state.DeckUI.deck.words[0] : {};
      }
    }, {
      key: "conjugatedVerbStrings",
      get: function get() {
        return _stores.ConjugatedVerbStringStore.indexData;
      }
    }, {
      key: "conjugatedVerbString",
      get: function get() {
        return this.conjugatedVerbStrings.find(function (item) {
          return item.conceptId === _state.DeckUI.deck.conjugationTenseId;
        });
      }
    }, {
      key: "singular1pPronoun",
      get: function get() {
        if ((0, _utils.isBlank)(_state.DeckUI.deck) || (0, _utils.isBlank)(this.conjugatedVerbString)) {
          return;
        }
        if (_state.DeckUI.deck.languageId === 'FR' && _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.conjugatedVerbString.singular1p[0])) {
          return 'j\'';
        }
        return _constants.Constants.PRONOUN_STRINGS[_state.DeckUI.deck.languageId || 'DE'].singular_1p;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          word: this.word,
          conjugatedVerbString: this.conjugatedVerbString,
          singular1pPronoun: this.singular1pPronoun
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "wordId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "word", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "word"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugatedVerbStrings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugatedVerbStrings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugatedVerbString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugatedVerbString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "singular1pPronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "singular1pPronoun"), _class2.prototype), _class2)) || _class;
};
ConjugationTableWrapper.displayName = 'ConjugationTableWrapper';
var _default = exports["default"] = ConjugationTableWrapper;